import type { toast } from '@side/pantry';
import { useSessionStorage } from 'react-use';

/**
 * A hook that allows you to set a toast message that will be displayed after next page load.
 *
 * This is useful for displaying a toast message after a user has completed an action that requires a page reload.
 *
 * The toast message will be displayed after the next page load, and will be removed from the session storage.
 *
 * @returns [toastConfig, setToastConfig]
 *
 * @example
 * const [toastConfig, setToastConfig] = useDelayedToast();
 * setToastConfig(['success', 'Team member onboarding request submitted successfully']);
 */
export const useDelayedToast = () => {
  return useSessionStorage<Parameters<typeof toast> | null>(
    'side-delayed-toast',
  );
};
